import { LiviaNav } from '../components/livia/nav';
import { LiviaSidebarBottom } from '../components/livia/sidebar';
import { LiviaLogo } from '../components/livia/logo';
import HelloView from '../components/livia/hello';

export const SIDEBAR_MENU = LiviaNav;
export const SIDEBAR_BOTTOM = LiviaSidebarBottom;

export const HELLO_CONTENT = HelloView;
export const LOGO = LiviaLogo;

export const RADIO_STATION = undefined;
export const HAS_AUTO_PLAY = true;

export const CHATBAR_CLASS = 'mix-blend-overlay opacity-70';
export const USERBALL_CLASS = '';
export const MICROPHONE_CLASS = '';
export const BG_CLASS = 'livia-bg';
export const LIV_NAME = '';
export const USE_ELEVENLABS = false;
export const APP_NAME = 'livia';
export const API_NAME = 'livia';

export const ASK_LIV = 'Posez-moi une question…';
